import Client from './Clients/AxiosClient'
const resource = '/api/v1/materi-dokumen'

export default {
  get(page = 1) {
    return Client.get(`${resource}?page=${page}`)
  },
  show(id) {
    return Client.get(`${resource}/${id}`)
  },
  create(payload) {
    return Client.post(`${resource}`, payload)
  },
  update(payload, id) {
    return Client.post(`${resource}/${id}?_method=PUT`, payload)
  },
  delete(id) {
    return Client.delete(`${resource}/${id}`)
  },
}
